export class InsuranceDataModel {

  startInsuranceDate: Date;
  // youngestDriverAge: number;
}
